import { Layout, Menu } from "antd";
import {
  disputeIcon,
  feedbackIcon,
  logOutIcon,
  notification,
  prizeIcon,
  userIcon,
} from "../assets";
import "./layout.css";
import { Routes, Route, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { accessToken, refreshToken, userData } from "../redux/userDataSlice";
import Dashboard from "../pages/dashboard/dashboard";
import UserList from "../pages/userList/userList";
import Preference from "../pages/preference/Preference";
import EditPreference from "../pages/editpreference/EditPreference";
import NewPreference from "../components/newpreference/NewPreference";
import Like from "../pages/like/Likes";
import Posts from "../pages/posts/Posts";
import FeedBack from "../pages/feedBack/FeedBack";
import PushNotification from "../pages/pushNotification/PushNotification";
import GeneralPost from "../pages/generalPost/generalPost";
import ReportFeedBack from "../pages/reportFeedback/reportFeedback";
import NotifiyAlluser from "../pages/NotifiyAlluser/NotifiyAlluser";

const { Content, Sider } = Layout;
const LayoutDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const logOut = () => {
    dispatch(userData(null));
    dispatch(accessToken(""));
    dispatch(refreshToken(""));
  };

  return (
    <Layout
      style={{
        minHeight: "100vh",
      }}
    >
      <Sider
        style={{ background: "#0C3C9E", fontSize: "2rem", fontWeight: "400" }}
        width={280}
        collapsed={false}
      >
        <div
          onClick={() => navigate("/")}
          style={{
            paddingTop: "4rem",
            textAlign: "center",
            color: "#FFFFFF",
            fontSize: "2.3rem",
            cursor: "pointer",
            fontWeight: "400",
          }}
        >
          BEIDO
        </div>

        <Menu
          style={{ marginTop: "7rem" }}
          theme="#FFFFFF"
          defaultSelectedKeys={["1"]}
          mode="inline"
          items={[
            {
              key: "95-posts",
              label: "Posts",
              icon: <img className="icon" src={prizeIcon} alt="" />,
              onClick: () => navigate("/posts"),
              style: {
                marginBottom: "2rem",
                fontSize: "2rem",
                fontWeight: "400",
                color: "#FFFFFF",
              },
            },
            {
              key: "95-general-post",
              label: "General Post",
              icon: <img className="icon" src={prizeIcon} alt="" />,
              onClick: () => navigate("/general-post"),
              style: {
                marginBottom: "2rem",
                fontSize: "2rem",
                fontWeight: "400",
                color: "#FFFFFF",
              },
            },
            {
              key: "108-users",
              label: "Users",
              icon: <img className="icon" src={userIcon} alt="" />,
              onClick: () => navigate("/user-list"),
              style: {
                marginBottom: "2rem",
                fontSize: "2rem",
                fontWeight: "400",
                color: "#FFFFFF",
              },
            },
            {
              key: "108-notify",
              label: "All user notify",
              icon: <img className="icon" src={notification} alt="" />,
              onClick: () => navigate("/notify-all-users"),
              style: {
                marginBottom: "2rem",
                fontSize: "2rem",
                fontWeight: "400",
                color: "#FFFFFF",
              },
            },
            {
              key: "108-preference",
              label: "Preference",
              icon: <img className="icon" src={disputeIcon} alt="" />,
              onClick: () => navigate("/preference"),
              style: {
                marginBottom: "2rem",
                fontSize: "2rem",
                fontWeight: "400",
                color: "#FFFFFF",
              },
            },
            {
              key: "95-feedback",
              label: "Feedback",
              icon: <img className="icon" src={feedbackIcon} alt="" />,
              onClick: () => navigate("/feedback"),
              style: {
                marginBottom: "2rem",
                fontSize: "2rem",
                fontWeight: "400",
                color: "#FFFFFF",
              },
            },
            {
              key: "95-report-feedback",
              label: "Report Feedback",
              icon: <img className="icon" src={feedbackIcon} alt="" />,
              onClick: () => navigate("/report-feedback"),
              style: {
                marginBottom: "2rem",
                fontSize: "2rem",
                fontWeight: "400",
                color: "#FFFFFF",
              },
            },
            {
              key: "logout",
              label: "Log Out",
              icon: <img className="icon1" src={logOutIcon} alt="" />,
              onClick: logOut,
              style: {
                marginTop: "5rem",
                fontSize: "2rem",
                fontWeight: "400",
                color: "#FFFFFF",
              },
            },
          ]}
        />
      </Sider>
      <Layout className="site-layout">
        <Content
          style={{
            background: "#fff",
            padding: "2rem",
          }}
        >
          <Routes>
            <Route path="/" element={<Dashboard />}></Route>
            <Route path="/user-list" element={<UserList />}></Route>
            <Route path="/preference" element={<Preference />}></Route>
            <Route path="/editpreference" element={<EditPreference />}></Route>
            <Route path="/newpreference" element={<NewPreference />}></Route>
            <Route path="/like" element={<Like />}></Route>
            <Route path="/posts" element={<Posts />}></Route>
            <Route path="/feedback" element={<FeedBack />}></Route>
            <Route path="/general-post" element={<GeneralPost />}></Route>
            <Route path="/report-feedback" element={<ReportFeedBack />}></Route>
            <Route
              path="/notify-all-users"
              element={<NotifiyAlluser />}
            ></Route>
            <Route
              path="/pushnotification"
              element={<PushNotification />}
            ></Route>
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutDashboard;
